<template>
<svg width="15" height="27" viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 13.5C15 13.9839 14.8199 14.4678 14.4605 14.8367L3.14579 26.4461C2.42603 27.1846 1.25907 27.1846 0.539601 26.4461C-0.179867 25.7079 -0.179867 24.5108 0.539601 23.7722L10.5515 13.5L0.539949 3.22783C-0.179518 2.48931 -0.179518 1.29231 0.539949 0.554153C1.25942 -0.184715 2.42638 -0.184715 3.14614 0.554153L14.4609 12.1634C14.8203 12.5325 15 13.0163 15 13.5Z" fill="currentColor"/>
</svg>
</template>

<script>
export default {
  name: 'IconChevronRight'
};
</script>
